import { CommonModule } from '@angular/common';
import { Component,  ElementRef,  Input, OnInit, ViewChild } from '@angular/core';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'qr-code',
    template: `
<div #holder></div>
<div class="icons" *ngIf="!!showDownload">
  <icon [icon]="'COPY'" (click)="copy()"></icon>
  <icon [icon]="'DOWNLOAD'" (click)="download()"></icon>
</div>

`,
    styles: [`
  :host { display: flex; }
  .icons { margin-left: 20px; display: flex; flex-direction: column; }
  icon { margin-bottom: 5px; cursor: pointer;  }
`],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class QRCodeComponent implements OnInit {
  @ViewChild('holder', { static: true }) holder: ElementRef<HTMLDivElement>
  @Input() showDownload = true

  @Input() value: string

  ngOnInit() {
    const QRCode = window['QRCode']
    window['qrElement'] = this.holder.nativeElement
    console.log({ QRCode, holder: this.holder.nativeElement })
    // tslint:disable-next-line:no-unused-expression
    new QRCode(this.holder.nativeElement, {
      text: this.value,
      width: 180,
      height: 180,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    });
  }

  copy() {
    navigator.clipboard.writeText(this.value)
  }

  download() {
    const uri = (this.holder.nativeElement.children[1] as HTMLImageElement).src.replace(/^data:image\/[^;]+/, 'data:application/octet-stream')
    const downloadLink = document.createElement("a")
    downloadLink.href = uri;
    downloadLink.download = "qrCode.jpg"
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }





}




